import React, { createContext, useContext, useState } from 'react';

const PopupContext = createContext();

export const usePopup = () => {
  const context = useContext(PopupContext);
  if (!context) {
    throw new Error('usePopup must be used within PopupProvider');
  }
  return context;
};

export const PopupProvider = ({ children }) => {
  const [popupEnabled, setPopupEnabled] = useState(true); // 📂 Modo popup ativado globalmente por padrão
  const [popupUrl, setPopupUrl] = useState(null);
  const [popupTitle, setPopupTitle] = useState('');

  const enablePopupMode = (enabled) => {
    setPopupEnabled(enabled);
  };

  const openPopup = (url, title) => {
    console.log('📂 Opening popup:', { url, title });
    setPopupUrl(url);
    setPopupTitle(title);
  };

  const closePopup = () => {
    console.log('✖️ Closing popup');
    setPopupUrl(null);
    setPopupTitle('');
  };

  return (
    <PopupContext.Provider
      value={{
        popupEnabled,
        popupUrl,
        popupTitle,
        enablePopupMode,
        openPopup,
        closePopup,
      }}
    >
      {children}
    </PopupContext.Provider>
  );
};
